import { Modal } from 'aui';
import Content from './Content';

type TProps = {
  visible?: boolean;
  onCancel: () => void;
};

const CloneModal = (props: TProps) => {
  const { visible, onCancel } = props;

  return (
    <>
      {visible && (
        <Modal
          open={visible}
          onCancel={onCancel}
          destroyOnClose
          bodyStyle={{
            padding: '0px',
          }}
          size={'560'}
          footer={null}
        >
          <Content onCancel={onCancel} />
        </Modal>
      )}
    </>
  );
};

export default CloneModal;
